import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Article = styled.article`
  margin: 0 auto;
  width: 100%;
  background-color: ${({ colourOverrideBackground }) => colourOverrideBackground || themeGet('colors.neutral_1')};
  padding: 60px 40px;

  h1,
  h2,
  h3,
  h4 {
    margin: 25px 0 10px;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  li {
    color: ${({ colourOverrideText }) => colourOverrideText || themeGet('colors.neutral_3')};
  }

  h1:first-child {
    margin-top: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 60px 130px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 60px 200px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 60px 270px;
  }
`;
